import { computed } from 'mobx';

import { jwtStore } from '.';
import { UserType } from '../types';

class UserStore {
  // Private instance
  private static _instance: UserStore;

  /**
   * Use UserStore.instance to retrieve an instance of this class.
   */
  private constructor() { }

  /**
   * Instance of UserStore.
   */
  public static get instance() {
    if (!this._instance) {
      this._instance = new UserStore();
    }

    return this._instance;
  }

  /**
   * User's email address.
   */
  @computed
  public get email(): string {
    return jwtStore.parsed.email;
  }

  /**
   * User's first name.
   */
  @computed
  public get firstName(): string {
    return jwtStore.parsed.first_name;
  }

  /**
   * User's last name.
   */
  @computed
  public get lastName(): string {
    return jwtStore.parsed.last_name;
  }

  /**
   * If user can update the profile.
   */
  @computed
  public get canUpdate(): boolean {
    return jwtStore.parsed.can_update;
  }

  /**
   * The type of the user, mentor or mentee.
   */
  @computed
  public get userType(): UserType {
    return jwtStore.parsed.is_mentor ? UserType.MENTOR : UserType.MENTEE
  }

  /**
   * User ID.
   *
   * TODO: Pending backend update, this field will no longer be necessary
   */
  @computed
  public get userId(): number {
    return Number(jwtStore.parsed.user_id);
  }

  /**
   * Check if the user is signed in.
   */
  @computed
  public get isSignedIn(): boolean {
    return !!jwtStore.rawToken;
  }
}

export default UserStore;
export const userStore = UserStore.instance;


// WEBPACK FOOTER //
// ./src/stores/UserStore.ts